var exports = {
  "H": "xae11d333--ad3671--preload-overlay",
  "R": "xae11d333--ad3671--preloader",
};

module.exports = exports;
